import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { Link } from 'react-router-dom';
import { getFromLocalStorage } from 'utlis/helpers/Common/CommonHelperFunctions';
import { getURL } from 'utlis/Apis/QuickBooks_API';

import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function QucikBooksConnect(props) {
    // props
    const { authState } = props
    // const redirectUrl = "https://staging.commercey.com/api/integrations/public/quickbook"
    // const clientId = "AB1O7WazM5whpdkX0MfyQm18IaQTZQl3BdVkCY4tEj5BNJBX1P"

    // store url
    const [storeUrl] = useStoreUrl()

    const [url, setUrl] = useState("")

    useEffect(() => {
        const qb_ref_token = getFromLocalStorage("qb_ref_token")
        if (qb_ref_token) {
            props.history.push(storeUrl + '/settings/integration/quickbooks/settings')
        } else {
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            getURL(headers).then(res => {
                setUrl(res.data.url)
            }).catch(e => {
                console.log(e)
            })

        }
    }, [props])
    return (
        <section id="app-integration-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-integrations">
                    <Link
                        className="st-btn st-btn-link text-primary border-light bg-transparent no-min-width st-btn-sm p-0 min-height-auto"
                        to={storeUrl + "/settings/integration"}
                    >
                        <FeatherIcon
                            icon="arrow-left"
                            size="14"
                            className="icon me-2" />
                        <span>Back</span>
                    </Link>
                    <div className="app-header-integrations mb-3">
                        <p className="app-heading text-capitalize">QucikBooks Analytics</p>
                        <p className="app-desc">Access And Manage Your Books From Your Computer, Laptop, Tablet, Or Smartphone Anytime You Choose.</p>
                    </div>
                    <Col xs={12} md={12} lg={12} className="px-0">
                        <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block">
                                <div className="integrations-top-content border-bottom ">
                                    <div className="app-header-wrapper heading-sm mb-1 pad-25-R">
                                        <div className="d-flex align-items-center  pad-12-B">
                                            <FeatherIcon
                                                icon="bar-chart"
                                                size="26"
                                                className="icon me-1" />
                                            <span className="app-heading text-capitalize">QuickBooks</span>
                                        </div>
                                        <p className="app-integrations-desc">Image result for quickbooks integration Intuit Quickbooks is a popular cloud and on- premise accounting solution that enables users to manage financial, invoice, payments and billing, payroll, taxes, and inventory management data.</p>
                                        <ul className="integrations-list">
                                            <li>Access and manage your books from your computer, laptop, tablet, or smartphone anytime you choose.</li>
                                            <li>Create access privileges so that your colleague or accountant can login and work with your data online.</li>
                                            <li>Know exactly how much money you have and how much you owe at any moment - your data is synced and backed up automatically.</li>
                                        </ul>
                                    </div>
                                    <div className="d-flex">
                                        image
                                    </div>
                                </div>
                                <div className="pad-20 integrations-bottom-content d-flex justify-content-between">
                                    <div className="content-right">
                                        <div className="d-flex align-items-center " >
                                            <span className="app-heading text-capitalize me-3">QuickBooks Integration</span>
                                            <button
                                                type="button"
                                                className="st-btn no-min-width st-btn-gray st-btn-sm  min-height-auto d-flex align-items-center justify-content-center me-2">
                                                Inactive
                                            </button>
                                        </div>
                                        <p className="app-integrations-desc pad-12-T">
                                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                                        <p className="app-integrations-desc pad-12-T">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                                        <div className="mt-3">
                                            {url ? <a href={url}
                                                className="st-btn  st-btn-primary  st-btn-sm d-inline-block no-min-width min-height-auto align-items-center justify-content-center me-2"
                                            >Connect to QuickBooks</a> : "loading.."}
                                            {/* <a href={"https://appcenter.intuit.com/connect/oauth2?client_id=" + clientId + "&redirect_uri=" + redirectUrl + "&response_type=code&scope=com.intuit.quickbooks.accounting%20openid&state=testState"}
                                                className="st-btn  st-btn-primary  st-btn-sm d-inline-block no-min-width min-height-auto align-items-center justify-content-center me-2"
                                            >Connect to QuickBooks</a> */}
                                            {/* <Link
                                                to={storeUrl + "/settings/integration/quickbooks/settings"}
                                                className="st-btn  st-btn-primary  st-btn-sm d-inline-block no-min-width min-height-auto align-items-center justify-content-center me-2"
                                            ></Link> */}

                                        </div>
                                    </div>
                                    <div className="app-card-content border st-default-rounded-block pad-12">
                                        <p className="app-heading-card text-capitalize me-3">About QuickBooks Integration</p>
                                        <p className="app-desc-card text-capitalize me-3">Access and manage your books from your computer, laptop, tablet, or smartphone anytime you choose.</p>
                                        <p className="app-desc-card text-primary text-capitalize me-3 st-fw-600">QuickBooks Support Article</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(QucikBooksConnect)